var _desc, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileAviBw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 63,
    viewBox: "0 0 50 63",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Canvas",
    transform: "translate(11281 -935)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__file-avi-bw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path0_fill",
    transform: "translate(-11281 935)",
    fill: "#D9DEE0"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Burger_Angus_Burger"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path1_fill",
    transform: "translate(-11264.4 979.119)",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path2_fill",
    transform: "matrix(1 0 0 -1 -11268.9 966.368)",
    fill: "#FFFFFF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -11264.4 974.665)",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "file-avi-bw_svg__file-avi-bw_svg__mask0_alpha",
    "mask-type": "alpha"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__mask0_outline_ins"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path3_fill",
    transform: "matrix(1 0 0 -1 -11264.4 974.665)",
    fill: "#FFFFFF"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Group",
    mask: "url(#file-avi-bw_svg__file-avi-bw_svg__mask0_alpha)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path4_fill",
    transform: "matrix(1 0 0 -1 -11265.3 975.527)",
    fill: "#4F4F4F"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -11261.6 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -11261.6 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path5_fill",
    transform: "matrix(1 0 0 -1 -11261.6 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -11261.6 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -11249.3 972.009)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -11249.3 968.854)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path7_fill",
    transform: "matrix(1 0 0 -1 -11249.3 965.728)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path8_fill",
    transform: "matrix(1 0 0 -1 -11249.3 962.572)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path6_fill",
    transform: "matrix(1 0 0 -1 -11261.6 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path8_fill",
    transform: "matrix(1 0 0 -1 -11249.3 959.553)",
    fill: "#4F4F4F"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-avi-bw_svg__file-avi-bw_svg__Vector"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#file-avi-bw_svg__file-avi-bw_svg__path9_fill",
    transform: "matrix(1 0 0 -1 -11257.2 968.189)",
    fill: "#4F4F4F"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path0_fill",
    d: "M 35.7147 0L 3.57076 0C 1.60081 0 7.27601e-17 1.55148 7.27601e-17 3.47066L 7.27601e-17 58.6161C 7.27601e-17 60.5333 1.60081 62.087 3.57076 62.087L 46.4292 62.087C 48.4033 62.087 50 60.5333 50 58.6161L 50 13.8826L 35.7147 0ZM 35.7147 4.90695L 44.951 13.8826L 35.7147 13.8826L 35.7147 4.90695ZM 46.4296 58.6161L 3.57076 58.6161L 3.57076 3.47066L 32.1432 3.47066L 32.1432 13.8826C 32.1432 15.7997 33.7404 17.3533 35.7139 17.3533L 46.4292 17.3533L 46.4292 58.6161L 46.4296 58.6161Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path1_fill",
    d: "M 6.89065 7.3252C 6.92514 7.41486 6.94236 7.49073 6.94236 7.5528C 6.94236 7.69764 6.89065 7.82179 6.78715 7.92525C 6.6837 8.02871 6.55612 8.08046 6.40434 8.08046C 6.30088 8.08046 6.20089 8.05287 6.10433 7.99769C 6.01463 7.93562 5.94913 7.85285 5.90774 7.74939L 5.32834 6.3009L 1.61402 6.3009L 1.02429 7.74939C 0.976012 7.85285 0.907041 7.93562 0.817377 7.99769C 0.727673 8.05287 0.631112 8.08046 0.527655 8.08046C 0.375917 8.08046 0.248298 8.02871 0.144841 7.92525C 0.0482802 7.8149 1.72673e-07 7.68732 1.72673e-07 7.54244C 1.72673e-07 7.47346 0.0172635 7.39417 0.0517494 7.3045L 2.95905 0.362118C 3.06251 0.120705 3.23151 4.6792e-08 3.46602 4.6792e-08C 3.71432 4.6792e-08 3.88332 0.120705 3.97298 0.362118L 6.89065 7.3252ZM 1.97614 5.41113L 4.96622 5.41113L 3.48671 1.72783L 1.97614 5.41113ZM 13.192 4.6792e-08C 13.3438 4.6792e-08 13.461 0.0413831 13.5438 0.124153C 13.6334 0.206928 13.6783 0.313838 13.6783 0.444889C 13.6783 0.527659 13.6576 0.61733 13.6162 0.713895L 10.5537 7.73903C 10.4641 7.96663 10.3019 8.08046 10.0674 8.08046C 9.84669 8.08046 9.68463 7.96663 9.58117 7.73903L 6.54968 0.807011C 6.4945 0.662162 6.46691 0.541457 6.46691 0.444889C 6.46691 0.306941 6.50829 0.200026 6.59106 0.124153C 6.68076 0.0413831 6.80144 4.6792e-08 6.95318 4.6792e-08C 7.19462 4.6792e-08 7.36016 0.10691 7.44982 0.320735L 10.0571 6.56989L 12.7057 0.320735C 12.754 0.196578 12.8161 0.113808 12.892 0.0724245C 12.9679 0.0241402 13.0678 4.6792e-08 13.192 4.6792e-08ZM 15.461 8.08046C 15.3093 8.08046 15.1816 8.02871 15.0782 7.92525C 14.9747 7.82179 14.923 7.69422 14.923 7.54244L 14.923 0.538009C 14.923 0.379366 14.9747 0.251759 15.0782 0.155195C 15.1816 0.051733 15.3093 4.6792e-08 15.461 4.6792e-08C 15.6196 4.6792e-08 15.7472 0.051733 15.8438 0.155195C 15.9473 0.251759 15.999 0.379366 15.999 0.538009L 15.999 7.54244C 15.999 7.69422 15.9473 7.82179 15.8438 7.92525C 15.7472 8.02871 15.6196 8.08046 15.461 8.08046Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path2_fill",
    d: "M 2.00509 0.771819L 5.80639 0L 17.8304 9.4341L 18.1269 10.2382C 18.3157 10.8901 18.2078 11.5942 17.8304 12.168C 17.4799 12.7417 16.8868 13.1589 16.2128 13.3154L 5.80639 15.7667C 5.61769 15.8189 5.40202 15.845 5.18635 15.845C 4.70107 15.845 4.24276 15.7146 3.81139 15.4799C 3.21828 15.1409 2.78692 14.5672 2.62517 13.9152L 0.0909576 3.84904C -0.0977599 3.19709 0.0100785 2.49298 0.387514 1.91926C 0.73799 1.34554 1.3311 0.92829 2.00509 0.771819Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path3_fill",
    d: "M 2.97151 0L 16.6405 0C 18.267 0 19.612 1.31411 19.612 2.97238L 19.612 16.6453C 19.612 18.2723 18.2983 19.6177 16.6405 19.6177L 2.97151 19.6177C 1.345 19.6177 0 18.3036 0 16.6453L 0 2.97238C 0 1.3454 1.31372 0 2.97151 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path4_fill",
    d: "M 17.5026 -2.61531e-09L 3.8337 -2.61531e-09L 3.8337 1.72439L 17.5026 1.72439L 17.5026 -2.61531e-09ZM 3.8337 -2.61531e-09C 1.6936 -2.61531e-09 -2.61531e-09 1.73757 -2.61531e-09 3.83458L 1.72439 3.83458C 1.72439 2.6776 2.65823 1.72439 3.8337 1.72439L 3.8337 -2.61531e-09ZM -2.61531e-09 3.83458L -2.61531e-09 17.5075L 1.72439 17.5075L 1.72439 3.83458L -2.61531e-09 3.83458ZM -2.61531e-09 17.5075C -2.61531e-09 19.6477 1.7367 21.3421 3.8337 21.3421L 3.8337 19.6177C 2.67769 19.6177 1.72439 18.684 1.72439 17.5075L -2.61531e-09 17.5075ZM 3.8337 21.3421L 17.5026 21.3421L 17.5026 19.6177L 3.8337 19.6177L 3.8337 21.3421ZM 17.5026 21.3421C 19.6428 21.3421 21.3364 19.6046 21.3364 17.5075L 19.612 17.5075C 19.612 18.6645 18.6781 19.6177 17.5026 19.6177L 17.5026 21.3421ZM 21.3364 17.5075L 21.3364 3.83458L 19.612 3.83458L 19.612 17.5075L 21.3364 17.5075ZM 21.3364 3.83458C 21.3364 1.69446 19.5997 -2.61531e-09 17.5026 -2.61531e-09L 17.5026 1.72439C 18.6587 1.72439 19.612 2.65814 19.612 3.83458L 21.3364 3.83458Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path5_fill",
    d: "M 1.5367 0L 0 0L 0 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path6_fill",
    d: "M 1.5367 0L 0 0L 0 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path7_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48645L 1.5367 1.48645L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path8_fill",
    d: "M 1.5367 0L -4.45403e-14 0L -4.45403e-14 1.48646L 1.5367 1.48646L 1.5367 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "file-avi-bw_svg__file-avi-bw_svg__path9_fill",
    d: "M 0.296556 6.58474C 0.242636 6.58474 0.188717 6.58474 0.161758 6.55864C 0.0539188 6.50652 -6.34803e-15 6.40219 -6.34803e-15 6.29787L -6.34803e-15 0.299899C -6.34803e-15 0.195586 0.0539188 0.0912734 0.161758 0.0391173C 0.269596 -0.0130391 0.377435 -0.0130391 0.458315 0.0391173L 5.49978 3.03811C 5.58064 3.09026 5.63458 3.19457 5.63458 3.29889C 5.63458 3.4032 5.58064 3.48144 5.49978 3.55967L 0.458315 6.53258C 0.404395 6.55864 0.350475 6.58474 0.296556 6.58474Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAviBw);
export default __webpack_public_path__ + "static/media/file-avi-bw.b098a94cd79fd075a8afbf9a4c8a0c9b.svg";
export { ForwardRef as ReactComponent };